import styled from 'styled-components';

export const ToggleThemeContainer = styled.div<{ isDark: boolean }>`
  width: 3.8rem;
  height: 2rem;
  position: relative;

  display: flex;
  align-items: center;
  justify-content: space-between;

  border-radius: 2rem;
  margin: 0.5rem;
  padding: 0 0.2rem;

  cursor: pointer;
  background-color: ${(props) => props.theme.colors.backgroundLight};

  transition: all 0.3s ease;
`;

export const IconWrapper = styled.div<{ active: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.5rem;
    z-index: 2;
    color: ${(props) => props.active ? props.theme.colors.onPrimary : props.theme.colors.textLight};

    transition: color 0.3s;
`;

export const Slider = styled.div<{ isDark: boolean }>`
    position: absolute;
    top: 50%;
    transform: translateY(-50%) translateX(${(props) => props.isDark ? '2.2rem' : '0'});
    left: 0.1rem;

    width: 1.8rem;
    height: 1.8rem;
    background-color: ${(props) => props.theme.colors.primary};
    border-radius: 50%;
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);

    transition: transform 0.3s cubic-bezier(0.45, 0.05, 0.55, 0.95);
`;

export default ToggleThemeContainer;
